import React, {Component} from 'react'
import "amazon-connect-streams"
import "amazon-connect-chatjs"
import Template from "../Components/Templates"
import {Container, Row} from "react-bootstrap"
import axios from "axios"
import HEADER_SVG from "../images/u14.png"
import {datadogLogs} from '@datadog/browser-logs'
import {checkEmptyInputText, keydownHandler, openUrl, getTimeAMPMFormat} from "../utils/commonHelper";
import TextareaAutosize from 'react-textarea-autosize';
import {transformFirstSystemMessage, transformSecondSystemMessage} from '../utils/transformers';
import {
    CONNECT_EVENT_CHAT_ENDED,
    CONNECT_EVENT_JOINED,
    CONNECT_EVENT_LEFT,
    CONNECT_EVENT_TRANSFER_FAILED, CONNECT_EVENT_TRANSFER_SUCCEEDED,
    CONNECT_EVENT_TYPING,
    CONTENT_TYPE_EVENT,
    CONTENT_TYPE_FEEDBACK,
    CONTENT_TYPE_TEXT,
    CONTENT_TYPE_TRANSFER,
    CONTENT_TYPE_TYPING,
    DISPLAY_NAME_BOT,
    DISPLAY_NAME_SYSTEM_MESSAGE,
    MSG_CANCEL_LIVE_CHAT,
    MSG_GET_INTENT_DESCRIPTION,
    MSG_LEX_BOT_ENTER_CHAT,
    MSG_START_CHAT,
    MSG_WAITING_AGENT,
    QUEUE_TYPE_DEFAULT,
    QUEUE_TYPE_PRESCRIPTION_REFILL_REQUEST,
    QUEUE_TYPE_STANDALONE_CHAT,
    ROLE_AGENT,
    ROLE_CUSTOMER,
    ROLE_SYSTEM,
    TIMEOUT_CUSTOMER_MESSAGE,
    TIMEOUT_END_LIVE_CHAT,
    TIMEOUT_SHOW_CHATBOT_MESSAGE,
    TIMEOUT_TYPING_EVENT,
    TIMEOUT_WAITING_AGENT,
    TIMEOUT_WAITING_QUEUE_INFO,
    TYPE_EVENT,
    TYPE_MESSAGE
} from "../utils/constants";
import {
    addIntentsHistory,
    clearIntentsHistory,
    enableIntentsHistory,
    getBackToIntentHistoryMessage,
    isIntentsHistoryEnabled,
    restoreIntentsHistory,
    updateLastIntentHistory
} from "./IntentsHistory";
import {CookieHelper} from "../utils/cookieHelper";
import {SEND_MESSAGE_BUTTON} from "./Images";
import {ChatSound} from "../utils/Sound";

const Timers = {
    waitingAgent: null,
    waitingQueueInfo: null,
    endLiveChat: null,
    typingEvent: null,
    showChatbotMessage: null,
    scrollMessages: null,
    newTimeout: (name, timeoutId) => {
        Timers.clearTimeoutByName(name);
        Timers[name] = timeoutId;
    },
    clearTimeoutByName: (name) => {
        if (Timers[name]) {
            clearTimeout(Timers[name]);
            Timers[name] = null;
        }
    },
    newInterval: (name, intervalId) => {
        Timers.clearIntervalByName(name);
        Timers[name] = intervalId;
    },
    clearIntervalByName: (name) => {
        if (Timers[name]) {
            clearInterval(Timers[name]);
            Timers[name] = null;
        }
    }
};

export default class Main extends Component {
    constructor(props) {
        super(props)

        const chatOpts = props.data ? JSON.parse(atob(props.data)) : {};
        const isWidget = !!props.data;

        if (!chatOpts.username) {
            chatOpts.username = "Customer_" + this.makeId()
        }
        if (!chatOpts.customerName) {
            chatOpts.customerName = "Customer #" + this.makeId(4, '0123456789')
        }
        if (!chatOpts.fontName) {
            chatOpts.fontName = "Roboto"
        }

        const userParams = props.userParams ? props.userParams : {};
        if (userParams.username) {
            chatOpts.customerName = userParams.username;
        }

        const isStandalone = (props.config || {}).isStandalone || false;

        this.cookieHelper = new CookieHelper((props.startQueueName) ?
                props.startQueueName
                :
                (userParams.mrn + userParams.department + userParams.ref).toString(),
            isStandalone
        );

        if (!chatOpts.connectKeys && isStandalone) {
            chatOpts.connectKeys = this.cookieHelper.getConnectKeys();
        }

        this.state = {
            isWidget: isWidget,
            isStandalone: isStandalone,
            chatInitiated: false,
            chatEnded: false,
            chatEndedByCustomer: false,
            chatCanceled: false,
            showEndChat: false,
            showEndLiveChat: false,
            message: "",
            messages: [],
            incomingChatbotMessages: [],
            localMessages: [],
            showLocalMessages: false,
            systemParticipantId: null,
            connectSuccess: false,
            lastTimeMessageSend: null,
            lastTimeTyping: null,
            isTyping: true,
            attempts: 0,
            lexEnter: false,
            showCancelButton: false,
            cancelButtonTitle: null,
            showRestartChat: false,
            needShowRestartChat: true,
            chatSession: null,
            feedbackValue: {},
            showFeedback: false,
            prescription: null,
            currentQueueName: null,
            agentConnected: false,
            beforeConnectToAgent: false,
            askName: false,
            askDOB: false,
            feedbackLoaderStatus: 0,
            agents:{},
            showTimeoutMessage:false,
            windowFocused: true,
            widgetWindowFocused: true,
            skipFeedback:false,
            ...userParams,
            ...chatOpts
        }

        if (!this.state.apiKey) {
            this.state.apiKey = (this.props.config || {}).apiKey;
        }

        if (!this.state.avatarUrl) {
            this.state.avatarUrl = (this.props.config || {}).avatarUrl;
        }

        if (!this.state.cssUrl) {
            this.state.cssUrl = (this.props.config || {}).cssUrl;
        }

        enableIntentsHistory(((this.props.config || {}).enableIntentsHistory || false));

        if (this.state.newSession === undefined) {
            this.state.newSession = !this.state.connectKeys;
        }

        this.state.enableFeedbackForAllAgents = ((this.props.config || {}).enableFeedbackForAllAgents || false);

        this.messageSound = new ChatSound(chatOpts.incomingMessageSoundUrl ?
            chatOpts.incomingMessageSoundUrl
            :
            'https://static.odeza.com/assets/media/chatbot-incoming-message.mp3'
        );
    }

    onUpdateFeedback = (feedbackValue) => {
        this.setState({feedbackValue: feedbackValue})
    }

    getCurrentContactId = () => {
        const {contactId} = (this.state.contactId) ? this.state : (this.state.chatSession?this.state.chatSession.controller:{});
        return contactId;
    };

    waitingAgentTimer = () => {
        Timers.clearTimeoutByName('waitingAgent');
        return setTimeout(() => {
            if (this.state.chatSession) {
                this.state.chatSession.sendMessage({
                    contentType: CONTENT_TYPE_TEXT,
                    message: MSG_WAITING_AGENT
                });
            }
        }, TIMEOUT_WAITING_AGENT);
    };

    waitingQueueInfoTimer = (instanceId, queueId, contactId) => setTimeout(() => {
        if (this.state.agentConnected
            || this.state.chatCanceled
            || this.state.chatEnded
        ) {
            Timers.clearTimeoutByName('waitingQueueInfo');
            return;
        }
        const url = process.env.REACT_APP_AMAZON_API_URL +
            `/queue/waitinginfo?instance_id=${instanceId}&queue_id=${queueId}&contact_id=${contactId}`;
        axios.get(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                let _messages = this.state.messages;
                for (let i = _messages.length - 1; i >= 0; i--) {
                    if (_messages[i] && _messages[i].chatbotIsWaitingInfo) {
                        _messages[i].Content = (response.data.message) ? response.data.message : _messages[i].Content;
                        this.setState({
                            messages: _messages
                        });
                        break;
                    }
                }
            })
            .finally(() => {
                Timers.newTimeout('waitingQueueInfo', this.waitingQueueInfoTimer(instanceId, queueId, contactId));
            });
    }, TIMEOUT_WAITING_QUEUE_INFO);

    requestLeaveQueueWaiting = (instanceId, queueId, contactId) => {
        try {
            const url = process.env.REACT_APP_AMAZON_API_URL +
                `/queue/waitinginfo?instance_id=${instanceId}&queue_id=${queueId}&contact_id=${contactId}&delete=1`;
            axios.get(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
        } catch (e) {}
    };

    endLiveChatTimer = () => setTimeout(() => {
        Timers.clearTimeoutByName('endLiveChat');
        this.endChat();
        this.setState({
            showTimeoutMessage:true,
        })
    }, TIMEOUT_END_LIVE_CHAT);

    updateLastMessageDate = () => {
        let needUpdate;
        let curDate = new Date();
        if (!this.state.lastTimeMessageSend) {
            this.state.lastTimeMessageSend = new Date();
            needUpdate = true;
        } else {
            needUpdate = (curDate.getTime() - this.state.lastTimeMessageSend.getTime() >= TIMEOUT_CUSTOMER_MESSAGE);
        }
        if (needUpdate) {
            try {
                const contactId = this.getCurrentContactId();
                axios.patch(process.env.REACT_APP_AMAZON_API_URL + '/contacts?contactId=' + contactId,
                    'contactId=' + contactId, {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    });
            } catch (e) {
                console.log(e);
            }
            this.state.lastTimeMessageSend = curDate;
        }
    }

    updateCustomerName = async (name) => {
        try {
            const keys = this.getKeysObject(this.state.connectKeys);
            const contactId = this.getCurrentContactId();
            const instanceId = (this.instanceId) ? this.instanceId : ((keys.data || {}).instanceId || '');
            let queueType = (this.state.prescription) ? QUEUE_TYPE_PRESCRIPTION_REFILL_REQUEST : QUEUE_TYPE_DEFAULT;
            if (this.state.isStandalone) {
                const hookGetQueueType = ((this.props.config || {}).hooks || {}).getQueueType;
                if (hookGetQueueType) {
                    queueType = hookGetQueueType(this.props);
                    if (queueType === undefined) {
                        queueType = QUEUE_TYPE_STANDALONE_CHAT;
                    }
                }
            }
            let _name = name.replace(/[?%$&/\\`'"~:;_=<>\[\]{}+]/g, ''); // encode URI not work with Agent chat
            let urlData = encodeURI('instanceId=' + instanceId +
                '&contactId=' + contactId +
                '&name=' + _name +
                '&queueType=' + queueType
            );
            await axios.patch(process.env.REACT_APP_AMAZON_API_URL + '/contacts/attributes?' + urlData, urlData, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    fetchCssFromUrl = (src, externals = []) => {
        new Promise((resolve, reject) => {
            const style = document.createElement('link')
            style.setAttribute('href', src)
            style.setAttribute('rel', "stylesheet")
            style.setAttribute('type', "text/css")
            style.addEventListener('load', () => {
                resolve(externals.map(key => {
                    const ext = window[key]
                    typeof ext === 'undefined' && console.warn(`No external named '${key}' in window`)
                    return ext
                }))
            })
            // style.addEventListener('error', reject)
            document.getElementsByTagName('head')[0].appendChild(style)
        })
    }

    getKeysObject = (keys) => {
        try {
            if (typeof keys !== 'object') {
                keys = JSON.parse(keys);
            }
        } catch (e) {
        }
        return keys;
    }

    getKeys = async (username, customerName, newKeys = false) => {
        let self = this;
        if (self.state.connectKeys && !newKeys) {
            return this.getKeysObject(self.state.connectKeys);
        }

        let sessionAttributes;
        if (this.state.isStandalone) {
            const hookGetQueueType = ((this.props.config || {}).hooks || {}).getQueueType;
            let queueType = QUEUE_TYPE_STANDALONE_CHAT;
            if (hookGetQueueType) {
                queueType = hookGetQueueType(this.props);
                if (queueType === undefined) {
                    queueType = QUEUE_TYPE_STANDALONE_CHAT;
                }
            }
            sessionAttributes = {
                "customerName": customerName,
                "startQueueName": self.props.startQueueName ? self.props.startQueueName : '',
                "queueType": queueType,
                "additionalData": JSON.stringify({
                    mrn: self.state.mrn,
                    department: self.state.department,
                    ref: self.state.ref
                }),
            };
        } else {
            sessionAttributes = {
                "customerName": customerName,
                "startQueueName": self.props.startQueueName ? self.props.startQueueName : this.state.startQueue,
            };
        }

        return axios.post(process.env.REACT_APP_AMAZON_API_URL, JSON.stringify({
            "apiKey": this.state.apiKey,
            "isWidget": this.state.isWidget,
            "ParticipantDetails": {"DisplayName": customerName},
            "Username": username,
            "Attributes": sessionAttributes,
        }), {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                self.setState({connectKeys: response.data})
                const s_keys = JSON.stringify(response.data);
                window.parent.postMessage({'name': 'connectKeys', value: s_keys}, '*')
                if (this.state.isStandalone) {
                    this.cookieHelper.saveConnectKeys(s_keys);
                }
                return response.data
            })
            .catch(function (error) {
                self.setState({connectKeys: false})
            });
    };

    createSession = async (json) => {
        clearIntentsHistory();
        if (json) {
            if (json.data) {
                try {
                    const {ContactId, ParticipantId, ParticipantToken} = json.data.startChatResult

                    let firstStartMessage = ((this.props.config || {}).messages || {}).firstStartMessage;
                    const hookGetFirstStartMessages = ((this.props.config || {}).hooks || {}).getFirstStartMessages;
                    if (hookGetFirstStartMessages) {
                        firstStartMessage = hookGetFirstStartMessages(this.props);
                    }
                    if (firstStartMessage) {
                        this.setState({
                            messages: firstStartMessage.map(item => transformFirstSystemMessage(item.title))
                        });
                    }

                    const session = await window.connect.ChatSession.create({
                        chatDetails: { // REQUIRED
                            contactId: ContactId, // REQUIRED
                            participantId: ParticipantId, // REQUIRED
                            participantToken: ParticipantToken, // REQUIRED
                        },
                        options: { // optional
                            region: 'us-east-1', // optional, defaults to `region` set in `connect.ChatSession.setGlobalConfig()`
                        },
                        type: window.connect.ChatSession.SessionTypes.CUSTOMER, // REQUIRED
                    });
                    const {connectSuccess} = await session.connect();
                    if (!this.state.newSession || this.state.isStandalone) {
                        this.setState({
                            isTyping: false,
                            lexEnter: true,
                        })
                    }

                    let secondStartMessage = ((this.props.config || {}).messages || {}).secondStartMessage;
                    const hookGetSecondStartMessages = ((this.props.config || {}).hooks || {}).getSecondStartMessages;
                    if (hookGetSecondStartMessages) {
                        secondStartMessage = hookGetSecondStartMessages(this.props);
                    }
                    if (secondStartMessage) {
                        this.setState((prevState) => {
                            return {
                                messages: [
                                    ...prevState.messages,
                                    ...secondStartMessage.map(item => transformSecondSystemMessage(item.title))
                                ]
                            };
                        });
                    }

                    session.onMessage(event => {
                        this.onMessage(event);
                    });

                    session.onEnded(event => {
                        this.onChatEnded(event);
                    });

                    session.onConnectionBroken(event => {
                        this.onChatEnded(event);
                    });

                    session.onConnectionEstablished(this.onConnectionEstablished);

                    session.onTyping(event => {
                        const {data} = event
                        if (data.ParticipantRole === ROLE_AGENT) {
                            this.updateTypingEventTimer(true);
                        }
                    });

                    let messages = []
                    if (!this.state.newSession) {
                        messages = await this.loadTranscript(session);
                    }
                    this.setState({
                        connectSuccess: connectSuccess,
                        chatSession: session,
                        contactId: ContactId,
                        messages: [...this.state.messages, ...messages]
                    })

                    window.addEventListener("message", (e) => {
                        switch (e.data.name) {
                            case 'disconnect':
                                this.endChat();
                                break;
                        }
                    });

                    window.chatbotSession = session;

                    return connectSuccess;
                } catch (e) {
                    const {connectSuccess} = e
                    this.setState({
                        connectSuccess: connectSuccess
                    })
                    return connectSuccess
                }
            } else {
                return false
            }
        } else {
            return false
        }
    }

    onConnectionEstablished = (event) => {
        /* This method called 2 times when connection established.
           Last have event.data object.
         */
        if (event.data) {
            if (!this.state.chatInitiated) {
                this.setState({
                    chatInitiated: true,
                });
            } else {
                this.loadTranscript(this.state.chatSession)
                    .then(messages => {
                        let firstStartMessage = ((this.props.config || {}).messages || {}).firstStartMessage;
                        const hookGetFirstStartMessages = ((this.props.config || {}).hooks || {}).getFirstStartMessages;
                        if (hookGetFirstStartMessages) {
                            firstStartMessage = hookGetFirstStartMessages(this.props);
                        }
                        let secondStartMessage = ((this.props.config || {}).messages || {}).secondStartMessage;
                        const hookGetSecondStartMessages = ((this.props.config || {}).hooks || {}).getSecondStartMessages;
                        if (hookGetSecondStartMessages) {
                            secondStartMessage = hookGetSecondStartMessages(this.props);
                        }
                        let startMessages = [];
                        if (firstStartMessage) {
                            startMessages.push(firstStartMessage);
                        }
                        if (secondStartMessage) {
                            startMessages.push(secondStartMessage);
                        }
                        this.setState({
                            messages: [
                                ...startMessages,
                                ...messages
                            ]
                        });
                    });
            }
        }
    }

    loadTranscript = async (session) => {
        let result = [];
        const awsSdkResponse = await session.getTranscript({
            maxResults: 100,
            sortOrder: "ASCENDING"
        });
        const {Transcript} = awsSdkResponse.data;
        let states = Object.assign(this.state, {});
        const messages = Transcript.filter(message => message.Content !== MSG_LEX_BOT_ENTER_CHAT);
        messages.map((data, key, arr) => {
            if (data.ParticipantRole === ROLE_SYSTEM && data.Type === TYPE_MESSAGE) {
                let processedChatbotMsg = this.processIncomingChatbotMessage(data, true);
                if (processedChatbotMsg.newStates) {
                    const statesNames = Object.keys(processedChatbotMsg.newStates);
                    if (statesNames.length) {
                        this.setState(prevState => {
                            statesNames.map(name => {
                                prevState[name] = processedChatbotMsg.newStates[name]
                            });
                            return prevState;
                        });
                        states = Object.assign(states, processedChatbotMsg.newStates);
                    }
                }
                // replace waiting information & mark message
                if (processedChatbotMsg.jsonData && processedChatbotMsg.jsonData.waitingMsg) {
                    data.chatbotIsWaitingInfo = true;
                    data.Content = JSON.stringify(processedChatbotMsg.jsonData.waitingMsg);
                }
            }
            // add to result array
            result.push(data);
            // update states & get additional messages
            const processedResult = this.processMessage(data, states, true);
            if (processedResult.newStates) {
                const statesNames = Object.keys(processedResult.newStates);
                if (statesNames.length) {
                    this.setState(prevState => {
                        statesNames.map(name => {
                            prevState[name] = processedResult.newStates[name]
                        });
                        return prevState;
                    });
                    states = Object.assign(states, processedResult.newStates);
                }
            }
            if (processedResult.newMessages) {
                result.push(...processedResult.newMessages);
            }
        });
        // restore intents history
        restoreIntentsHistory(result);
        return result;
    }

    componentDidMount = () => {
        if (this.state.isStandalone) {
            const appHeight = () => {
                const el = document.getElementById('chat__wrap');
                if (el && el.style) {
                    el.style.setProperty('height', `${window.innerHeight}px`);
                }
            }
            window.addEventListener('resize', appHeight);
            appHeight();
        }

        datadogLogs.init({
            clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
            site: 'datadoghq.com',
            forwardErrorsToLogs: true,
            sampleRate: 100,
            service: 'customer-chat-app',
            env: process.env.REACT_APP_ENV
        });

        this.initiateChat();
        this.initiateChatScrolling();
    };

    componentWillUnmount = () => {
        Timers.clearTimeoutByName('waitingAgent');
        Timers.clearTimeoutByName('waitingQueueInfo');
        Timers.clearTimeoutByName('endLiveChat');
        Timers.clearTimeoutByName('typingEvent');
        Timers.clearIntervalByName('showChatbotMessage');
    };

    initiateChatScrolling = () => {
        window.isChatScrolling = false;
        window.lastKeycode = null;
        const chatScrollBy = (event, offset, timeout = 120) => {
            event.preventDefault();
            const isDirectionChanged = (window.lastKeycode !== event.keyCode);
            window.lastKeycode = event.keyCode;
            if (isDirectionChanged) {
                window.isChatScrolling = false;
                Timers.clearTimeoutByName('scrollMessages');
            }
            if (!window.isChatScrolling && this.messagesArea) {
                this.messagesArea.scrollBy({top: offset, behavior: 'smooth'});
                window.isChatScrolling = true;
                Timers.newTimeout('scrollMessages', setTimeout(() => {
                    window.isChatScrolling = false;
                }, timeout));
            }
        }

        document.addEventListener('keydown', (e) => {
            switch (e.keyCode) {
                case 33:
                    chatScrollBy(e, -400, 250);
                    break;
                case 34:
                    chatScrollBy(e, 400, 250);
                    break;
                case 38:
                    chatScrollBy(e, -100);
                    break;
                case 40:
                    chatScrollBy(e, 100);
                    break;
            }
        });

        window.addEventListener("focus", () => {
            if (this.state.isMobile) {
                setTimeout(() => this.scrollToBottom(), 700);
            }
        });

        document.addEventListener("visibilitychange", () => {
            if (!document.hidden) {
                setTimeout(() => this.scrollToBottom(), 700);
            }
        }, false);
    };

    initiateChat = async () => {
        window.addEventListener("message", (e) => {
            switch (e.data.name) {
                case 'isMobile':
                    const isMobile = e.data.value;
                    this.setState({isMobile: isMobile})
                    if (!isMobile && this.textarea) {
                        this.textarea.focus();
                    }
                    break;
                case 'windowFocused':
                    this.setState({windowFocused: e.data.value})
                    break;
            }
        });
        if (!this.state.isWidget && this.state.isStandalone) {
            window.addEventListener("focus", () => this.setState({
                windowFocused: true,
                widgetWindowFocused: true
            }));
            window.addEventListener("blur", () => this.setState({
                windowFocused: false,
                widgetWindowFocused: false
            }));
        } else {
            window.addEventListener("focus", () => this.setState({widgetWindowFocused: true}));
            window.addEventListener("blur", () => this.setState({widgetWindowFocused: false}));
        }

        if (this.state.cssUrl) {
            this.fetchCssFromUrl(this.state.cssUrl, ['eruda'])
        }

        this.setState({
            chatInitiated: false,
            chatEnded: false,
            chatEndedByCustomer: false,
            isTyping: true,
            needShowRestartChat: true,
        });

        Timers.newInterval('showChatbotMessage', this.initShowIncomingChatbotMessages());
        Timers.clearTimeoutByName('waitingAgent');
        Timers.clearTimeoutByName('waitingQueueInfo');
        Timers.clearTimeoutByName('endLiveChat');

        let {attempts, username, customerName} = this.state;
        let connectSuccess = false
        while (!connectSuccess && attempts < 3) {
            if (attempts && this.state.isDebug === undefined) {
                username = "Customer_" + this.makeId();
                if (!customerName) {
                    customerName = "Customer #" + this.makeId(4, '0123456789');
                }
                this.setState({
                    username: username,
                    customerName: customerName
                });
                window.parent.postMessage({'name': 'newUsername', value: username}, '*');
                this.cookieHelper.saveUserName(username);
            }
            const keys = await this.getKeys(username, customerName, attempts ? true : false);
            this.instanceId = (keys.data || {}).instanceId || '';
            connectSuccess = await this.createSession(keys);
            attempts++;
            this.setState({
                attempts: attempts
            });
        }

        if (this.state.isStandalone) {
            let isMobile = window.matchMedia("only screen and (max-width: 460px)").matches;
            this.setState({isMobile: isMobile});
            if (!isMobile && this.textarea) {
                this.textarea.focus();
            }
        }
    }

    initShowIncomingChatbotMessages = () => setInterval(() => {
        if (this.state.incomingChatbotMessages.length) {
            const msg = this.state.incomingChatbotMessages.shift();

            let processedChatbotMsg = this.processIncomingChatbotMessage(msg, false);
            if (processedChatbotMsg.newStates) {
                const statesNames = Object.keys(processedChatbotMsg.newStates);
                if (statesNames.length) {
                    this.setState(prevState => {
                        statesNames.map(name => {
                            prevState[name] = processedChatbotMsg.newStates[name]
                        });
                        return prevState;
                    });
                }
            }

            const processedMsg = processedChatbotMsg.jsonData;

            // replace waiting information & mark message
            if (processedMsg && processedMsg.waitingMsg) {
                msg.chatbotIsWaitingInfo = true;
                msg.Content = JSON.stringify(processedMsg.waitingMsg);
            }

            this.setState({
                isTyping: this.state.incomingChatbotMessages.length > 0
            });

            // Add messages to main array
            if (processedMsg && Array.isArray(processedMsg.title)) {
                processedMsg.title.map((titleItem, i, arr) => {
                    let _msg = {...msg};
                    _msg.Content = titleItem;
                    if (arr.length === i + 1) {
                        let _content = {...processedMsg};
                        _content.title = titleItem;
                        _msg.Content = JSON.stringify(_content);
                    }
                    this.setState(prevState => {
                        return {messages: [...prevState.messages, _msg]};
                    });
                });
            } else {
                this.setState(prevState => {
                    return {messages: [...prevState.messages, msg]};
                });
            }
        }
    }, TIMEOUT_SHOW_CHATBOT_MESSAGE);

    processIncomingChatbotMessage = (message, isRestored) => {
        let newStates = {};
        let jsonData = null;
        try {
            jsonData = JSON.parse(message.Content);
        } catch (e) {
        }

        if (jsonData) {
            // value is string!
            if (typeof jsonData.askName === 'string' && jsonData.askName === 'true'
                || typeof jsonData.askName === 'boolean' && jsonData.askName
            ) {
                newStates = Object.assign(newStates, {
                    askName: true,
                    lexEnter: true,
                    showLocalMessages: false,
                    beforeConnectToAgent: true
                });
            }

            // value is string!
            if (typeof jsonData.askDOB === 'string' && jsonData.askDOB === 'true'
                || typeof jsonData.askDOB === 'boolean' && jsonData.askDOB
            ) {
                newStates = Object.assign(newStates, {
                    askName: true,
                    askDOB: true,
                });
            }

            if (jsonData.cancelQueue === true
                || (jsonData.waitingMsg && jsonData.waitingMsg.cancelQueue === true)
            ) {
                Timers.newTimeout('waitingAgent', this.waitingAgentTimer());
                let buttonTitle = null;
                if (jsonData.cancelButtonTitle) {
                    buttonTitle = jsonData.cancelButtonTitle;
                }
                if (jsonData.waitingMsg) {
                    Timers.newTimeout('waitingQueueInfo', this.waitingQueueInfoTimer(jsonData.instanceId, jsonData.queueId, this.getCurrentContactId()));
                    if (jsonData.waitingMsg.cancelButtonTitle) {
                        buttonTitle = jsonData.waitingMsg.cancelButtonTitle;
                    }
                    newStates = Object.assign(newStates, {
                        instanceId: jsonData.instanceId,
                        queueId: jsonData.queueId,
                    });
                }
                newStates = Object.assign(newStates, {
                    showCancelButton: true,
                    cancelButtonTitle: buttonTitle,
                    askName: false,
                    askDOB: false,
                });
            }

            if (jsonData.redirectUrl && !isRestored) {
                openUrl(jsonData.redirectUrl, false, undefined, this.state.isStandalone);
            }

            //save link-buttons with "onlyRedirect"
            if (jsonData.type === 'interactive') {
                this.onlyRedirectButtons = [];
                if (jsonData.buttons && jsonData.buttons.length) {
                    try {
                        jsonData.buttons.forEach(button => {
                            if (button.onlyRedirect) {
                                this.onlyRedirectButtons.push(button);
                            }
                        });
                    } catch (e) {
                    }
                }
            }

            // check transfer start
            if (jsonData.type === TYPE_EVENT) {
                if (jsonData.chatTransfer) {
                    newStates = Object.assign(newStates, {
                        isTransferring: true,
                        chatTransferred:true,
                        currentQueueName: null, // when start transferring - reset queue name
                        agents: {
                            ...this.state.agents,
                            [message.ContactId]: {...this.state.agents[message.ContactId], chatEnded: false}
                        }
                    });
                }
                if (jsonData.queueName) {
                    newStates = Object.assign(newStates, {
                        currentQueueName: jsonData.queueName
                    });
                }
            }
        }

        return {
            newStates: newStates,
            jsonData: jsonData
        };
    }

    processMessage = (data, states, isRestored = false) => {
        let newStates = {};
        let newMessages = [];

        const contactId = (data.ContactId) ? data.ContactId : states.contactId;

        if (!isRestored) {
            Timers.newTimeout('endLiveChat', this.endLiveChatTimer());

            if (data.ParticipantRole === ROLE_CUSTOMER) {
                this.updateLastMessageDate();
            }
        }

        if (data.ParticipantRole === ROLE_CUSTOMER
            && data.Type === TYPE_MESSAGE
        ) {
            if (data.Content && data.Content.indexOf("sys_back:") === 0) {
                newStates = Object.assign(newStates, {
                    askName: false,
                    askDOB: false,
                });
            }
        }

        if (data.Type === TYPE_EVENT) {
            if (data.ParticipantRole === ROLE_AGENT
                && data.ContentType === CONNECT_EVENT_JOINED
            ) {
                Timers.clearTimeoutByName('waitingAgent');
                Timers.clearTimeoutByName('waitingQueueInfo');
                newStates = Object.assign(newStates, {
                    showEndLiveChat: true,
                    showCancelButton: false,
                    showFeedback: true,
                    agentConnected: true,
                    askName: false,
                    askDOB: false,
                    agents: {
                        ...this.state.agents,
                        [contactId]:{...this.state.agents[contactId],agentName: data.DisplayName}
                    },
                });
                try {
                    if (!this.state.windowFocused && !this.state.widgetWindowFocused) {
                        this.messageSound.play(false, true);
                    }
                } catch (e) {}
            }

            if([
                CONNECT_EVENT_JOINED,
                CONNECT_EVENT_TRANSFER_FAILED
            ].indexOf(data.ContentType) !== -1
            ) {
                newStates = Object.assign(newStates, {
                    isTransferring: false
                });
            }

            if (data.ContentType === CONNECT_EVENT_JOINED
                && data.ParticipantRole === ROLE_AGENT
            ) {
                newStates = Object.assign(newStates, {
                    contactId: data.ContactId  // don't use contactId constant!
                });
            }

            if (data.ContentType === CONNECT_EVENT_JOINED
                && data.ParticipantRole === ROLE_CUSTOMER
            ) {
                Timers.clearTimeoutByName('endLiveChat');
            }

            if (data.ContentType === CONNECT_EVENT_LEFT) {
                if (data.ParticipantRole === ROLE_AGENT) {
                    newStates = Object.assign(newStates, {
                        agentConnected: false
                    });
                }

                if (states.isTransferring
                    && !states.chatCanceled
                    && states.enableFeedbackForAllAgents
                ) {
                    newMessages.push({
                        Content: 'Please rate your chat with ' + (states.agentName || 'agent'),
                        ContentType: CONTENT_TYPE_FEEDBACK,
                        ContactId: contactId,
                        Type: TYPE_EVENT,
                        transferFeedback: true
                    });
                }

                if (!states.chatEnded
                    && !states.chatCanceled
                    && !states.isTransferring
                ) {
                    newStates = Object.assign(newStates, {
                        chatEnded: true,
                        agents: {
                            ...this.state.agents,
                            [contactId]:{...this.state.agents[contactId],chatEnded:true}
                        },
                    });
                    newMessages.push({
                        ContentType: CONNECT_EVENT_CHAT_ENDED,
                        Content: 'Ended by '+ (this.state.chatEndedByCustomer ? 'Customer' : 'Agent')+' ' + getTimeAMPMFormat(new Date()),
                        ContactId: contactId,
                        Type: TYPE_EVENT,
                    },{
                        Content: 'Did ' + (this.state.agentName || 'agent') + ' help you today?',
                        ContentType: CONTENT_TYPE_FEEDBACK,
                        ContactId: contactId,
                        Type: TYPE_EVENT,
                    });
                }
            }
        }

        return {
            newStates: newStates,
            newMessages: newMessages
        };
    }

    onMessage = (event) => {
        const {data} = event;

        const contactId = (data.ContactId) ? data.ContactId : this.state.contactId;

        if (this.state.isStandalone) {
            if ((!this.state.agentConnected || this.state.chatEnded || this.state.chatCanceled)
                && data.ContentType === CONNECT_EVENT_CHAT_ENDED
            ) {
                //Chat ended, ignore messages
                return;
            }
        } else {
            if (this.state.chatEnded && data.ContentType === CONNECT_EVENT_CHAT_ENDED) {
                return;
            }
        }
        if ((!this.state.agentConnected && this.state.chatEnded)
            && data.ContentType === CONNECT_EVENT_CHAT_ENDED
        ) {
            this.setState({
                showTimeoutMessage: true
            })
        }
        if ([MSG_LEX_BOT_ENTER_CHAT].indexOf(data.Content) !== -1) {
            try {
                this.state.chatSession.sendMessage({
                    contentType: CONTENT_TYPE_TEXT,
                    message: MSG_START_CHAT
                }).then(() => {
                    this.setState({
                        lexEnter: true,
                        showLocalMessages: false,
                        systemParticipantId: data.ParticipantId
                    });
                }).catch(() => {
                    this.endChat();
                });
            } catch (e) {
                this.endChat();
            }
        } else {
            if (data.ParticipantRole === ROLE_SYSTEM && data.Type === TYPE_MESSAGE) {
                // Chatbot message
                this.setState({
                    isTyping: true,
                    incomingChatbotMessages: [...this.state.incomingChatbotMessages, data]
                });
                // Save history
                addIntentsHistory(data);
            } else {
                // All other
                this.setState({
                    messages: [...this.state.messages, data]
                });
                if (data.ParticipantRole !== ROLE_CUSTOMER && data.Type === TYPE_MESSAGE) {
                    if (data.ParticipantRole === ROLE_AGENT) {
                        try {
                            if (!this.state.windowFocused && !this.state.widgetWindowFocused) {
                                this.messageSound.play(false, true);
                            }
                        } catch (e) {}
                    }
                    this.setState({
                        isTyping: false
                    });
                }
            }
        }

        const processedResult = this.processMessage(data, this.state);
        if (processedResult.newStates) {
            const statesNames = Object.keys(processedResult.newStates);
            if (statesNames.length) {
                this.setState(prevState => {
                    statesNames.map(name => {
                        prevState[name] = processedResult.newStates[name]
                    });
                    return prevState;
                });
            }
        }
        if (processedResult.newMessages) {
            this.setState(prevState => {
                return {
                    messages: [
                        ...prevState.messages,
                        ...processedResult.newMessages
                    ]
                };
            });
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.messages
            && this.state.messages
            && prevState.messages.length !== this.state.messages.length
        ) {
            this.scrollToBottom();
        }
    }

    changeMessage = (e) => {
        this.setState({
            message: e.target.value
        });
        this.sendTypingEvent();
    };

    sendTypingEvent = () => {
        let needSend = false;
        let curDate = new Date();
        if (!this.state.lastTimeTyping) {
            this.state.lastTimeTyping = new Date();
            needSend = true;
        } else {
            needSend = (curDate.getTime() - this.state.lastTimeTyping.getTime() >= TIMEOUT_TYPING_EVENT);
        }
        if (needSend) {
            if (this.state.chatSession !== null) {
                this.state.lastTimeTyping = curDate;
                this.state.chatSession.sendEvent({
                    contentType: CONNECT_EVENT_TYPING
                });
            }
        }
    };

    updateTypingEventTimer = (isTyping = true) => {
        Timers.clearTimeoutByName('typingEvent');
        this.setState({
            isTyping: isTyping
        });
        if (isTyping) {
            this.scrollToBottom();
            Timers.newTimeout('typingEvent', setTimeout(() => {
                this.setState({
                    isTyping: false
                });
                Timers.typingEvent = null;
            }, TIMEOUT_TYPING_EVENT));
        }
    }

    checkAskNameAndUpdate = async (message) => {
        if (this.state.messages.length && message && message.indexOf('sys_back:') === -1) {
            try {
                const lastMessage = this.state.messages.slice(-1).pop();
                if (lastMessage.Content) {
                    const data = JSON.parse(lastMessage.Content)
                    if (data.askName) {
                        if (data.queueType && data.queueType === QUEUE_TYPE_PRESCRIPTION_REFILL_REQUEST) {
                            this.state.prescription = {};
                            this.setState({
                                prescription: {}
                            });
                        } else {
                            this.state.prescription = null;
                            this.setState({
                                prescription: null
                            });
                        }
                        await this.updateCustomerName(message);
                    }
                }
            } catch (e) {
            }
        }
    }

    getOnlyRedirectButton = (message) => {
        if (this.onlyRedirectButtons && this.onlyRedirectButtons.length) {
            try {
                const userInput = message.replace(/\s+/g, ' ').toLowerCase().trim();
                for (let i = 0; i < this.onlyRedirectButtons.length; i++) {
                    const button = this.onlyRedirectButtons[i];
                    const buttonTitle = button.title.toLowerCase();
                    if (buttonTitle === userInput) {
                        return button;
                    }
                }
            } catch (e) {
            }
        }
        return false;
    }

    sendMessage = async (message = null, href = null, isFreeText = null) => {
        this.sendMessageButton.blur();
        this.setState({
            message: ""
        });

        if (!message
            || !this.state.lexEnter
            || checkEmptyInputText(message)
            || (message.indexOf('sys_back:') === 0 && this.state.agentConnected)
        ) {
            return false;
        }

        if (message.indexOf(MSG_GET_INTENT_DESCRIPTION) === -1) {
            updateLastIntentHistory({inputText: message});
        }

        if (isFreeText && ['back', 'go back', 'return'].indexOf(message.trim().toLowerCase()) !== -1
            && !this.state.agentConnected
            && !this.state.showCancelButton
        ) {
            try {
                message = getBackToIntentHistoryMessage();
                if (!message) {
                    return;
                } else {
                    updateLastIntentHistory(null);
                }
            } catch (e) {
                console.error(e)
            }
        }

        this.setState({
            lastTimeTyping: new Date(0),
            askName: false,
            askDOB: false,
        });

        await this.checkAskNameAndUpdate(message);

        try {
            const button = this.getOnlyRedirectButton(message);
            if (button !== false) {
                openUrl(button.url, button.newWindow === 1, undefined, this.state.isStandalone);
                return false;
            }

            // check normal user input
            if (!href) {
                try {
                    // stop show Chatbot messages
                    Timers.clearIntervalByName('showChatbotMessage');

                    if (this.lastMessageContext) {
                        this.lastMessageContext.setState({buttonClicked: true});
                    }

                    if (this.state.chatSession) {
                        await this.state.chatSession.sendMessage({
                            contentType: CONTENT_TYPE_TEXT,
                            message: message
                        });
                        this.setState({
                            message: "",
                            messageSending: false
                        });
                    } else {
                        this.setState({
                            message: "",
                            localMessages: [...this.state.localMessages, message]
                        });
                    }
                } finally {
                    // restore show Chatbot messages
                    setTimeout(() => {
                        if (!this.state.showCancelButton
                            && !this.state.showRestartChat
                            && !this.state.showEndLiveChat
                        ) {
                            this.updateTypingEventTimer(true);
                        }
                        Timers.newInterval('showChatbotMessage', this.initShowIncomingChatbotMessages());
                    }, 300);
                }

                if (!this.state.isMobile && this.textarea) {
                    this.textarea.focus();
                }

                return true;
            }
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    changeFeedbackMessage = (contactId, e) => {
        this.setState({
            feedbackValue:
                {
                    ...this.state.feedbackValue,
                    [contactId]: {...this.state.feedbackValue[contactId], 'feedbackMessage': e.target.value}
                }
        });
    }

    sendFeedback = (contactId,feedbackResult=false) => {
        this.setState({
            feedbackLoaderStatus:1,
        });
        try {
            const chatEnded = this.state.agents[contactId]?this.state.agents[contactId].chatEnded:""
            return new Promise((resolve) => {
                const result = feedbackResult !== false ? feedbackResult : this.state.feedbackValue[contactId] ? this.state.feedbackValue[contactId].feedbackResult : ""
                const helpReceived = this.state.feedbackValue[contactId] ? this.state.feedbackValue[contactId].helpReceived : ""
                const feedbackMessage = this.state.feedbackValue[contactId] ? this.state.feedbackValue[contactId].feedbackMessage : ""
                axios.put(process.env.REACT_APP_AMAZON_API_URL + '/feedback',
                    {
                        instanceId: this.instanceId || '',
                        contactId: contactId,
                        feedbackResult: result,
                        helpReceived: helpReceived,
                        feedbackMessage: feedbackMessage,
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(() => {
                        this.setState({
                            showFeedback: feedbackResult!== false?this.state.showFeedback:(!chatEnded && !this.state.showCancelFeedback),
                            showRestartChat: true,
                            feedbackLoaderStatus:0,
                            showCancelFeedback:false,
                            showCancelThanksMessage:true,
                            showThanksMessage:(result!=='' || helpReceived!=='' || feedbackMessage!=='')
                        });
                        if (feedbackResult !== false){
                            this.setState({
                                feedbackValue: {
                                    ...this.state.feedbackValue,
                                    [contactId]: {...this.state.feedbackValue[contactId], feedbackResult: feedbackResult}
                                }
                            })
                        }
                    })
                    .finally(() => {
                        this.scrollToBottom();
                        this.messagesArea.focus();
                        resolve();
                    });
            });
        } catch (e) {
            console.log(e);
        }
    };
    skipFeedback = () => {
        this.setState({
            showFeedback: false,
            showRestartChat: true,
            feedbackLoaderStatus:0,
            skipFeedback:true
        })
    }

    cleanupChat = () => {
        this.setState({
            chatSession: null,
            chatCanceled: false,
            showEndChat: false,
            showEndLiveChat: false,
            connectSuccess: false,
            attempts: 0,
            connectKeys: false,
            newSession: true,
            message: "",
            localMessages: [],
            incomingChatbotMessages: [],
            isTyping: false,
            showLocalMessages: false,
            lexEnter: false,
            showCancelButton: false,
            startQueue: false,
            agentConnected: false,
            beforeConnectToAgent: false,
            askName: false,
            askDOB: false,
        });
    }

    deleteChatCookie = () => {
        window.parent.postMessage({'name': 'deleteCookie', value: true}, '*');
    }

    endChat = (deleteCookie = true) => {
        this.setState({
            isTransferring: false,
            chatEndedByCustomer: true,
        });
        return new Promise((resolve, reject) => {
            try {
                if (deleteCookie) {
                    this.deleteChatCookie();
                    if (this.state.isStandalone) {
                        this.cookieHelper.deleteCookies();
                    }
                }
                if (!this.chatEnded && this.state.chatSession) {
                    this.state.chatSession.disconnectParticipant()
                        .finally(() => {
                            this.onChatEnded();
                            resolve();
                        });
                } else {
                    resolve();
                }
            } catch (ex) {
                reject(ex.message);
            }
        });
    }

    cancelLiveChat = () => {
        if(this.state.feedbackLoaderStatus){
            return false;
        }
        this.setState({
            chatCanceled: true,
            showCancelFeedback:this.state.chatTransferred,
            chatTransferred:false,
            showCancelButton: false,
            showFeedback: true,
            needShowRestartChat: false,
        });
        for (const s of document.getElementsByClassName("cancel-button")) {
            s.style.display = "none";
        }
        this.requestLeaveQueueWaiting(this.state.instanceId, this.state.queueId, this.getCurrentContactId());
        if (this.state.chatSession) {
            this.state.chatSession.sendMessage({
                contentType: CONTENT_TYPE_TEXT,
                message: MSG_CANCEL_LIVE_CHAT
            })
                .finally(() => {
                    if (this.state.isStandalone) {
                        this.endChat(true)
                            .finally(() => {
                                this.setState({
                                    filteredMessages:this.filterFeedbackMessage(),
                                })
                                /* Disable restart for Standalone chat */
                            });
                    } else {
                        this.endChat(false)
                            .finally(() => {
                                this.initiateChat();
                            });
                    }
                });
        }
    };

    endLiveChat = (needReload = false) => {
        this.setState((prevstate)=>({
            showEndLiveChat: false,
        }));
        return new Promise((resolve, reject) => {
            this.endChat(false)
                .then(() => {
                    if (needReload) {
                        this.setState({
                            messages: []
                        });
                        setTimeout(() => {
                            this.initiateChat();
                        }, 100);
                    }

                    this.setState({
                        messages:this.filterFeedbackMessage(),
                    });
                    resolve();
                })
                .catch((err) => {
                    reject('Can\'t End Chat: ' + err);
                });
        });
    };

    restartChat = () => {
        this.setState({
            showRestartChat: false,
            showThanksMessage: false,
        });
        if (this.state.isStandalone) {
            this.endLiveChat(false)
                .catch(err => {
                    console.log(err)
                })
                .finally(() => {
                    window.location.reload();
                });
        } else {
            this.endLiveChat(true);
        }
    };

    onChatEnded = (event) => {
        this.cleanupChat();
        this.state.chatEnded = true; // change immediately
        if (!this.state.isStandalone) {
            let lastMessage = false
            try {
                lastMessage = JSON.parse(this.state.messages.findLast(message=>message.Type!==TYPE_EVENT).Content)
            } catch (e){}
            this.setState({
                showRestartChat: this.state.needShowRestartChat
                    && this.state.needShowRestartChat&&
                    lastMessage
                    (
                        !lastMessage.buttons
                        ||(lastMessage.buttons && lastMessage.buttons.findIndex(button=>button.title==='Start Over') === -1)
                    )
            });
            this.lastMessageContext.setState({
                buttonClicked: true
            })
        }
        setTimeout(() => {
            this.scrollToBottom();
        }, 100);
    }

    onButtonClick = async (message, href, additionalInfo = null) => {
        if (href) {
            let newWindow = false;
            if (additionalInfo && additionalInfo.hasOwnProperty('button')) {
                if (additionalInfo.button.hasOwnProperty('intent')) {
                    await this.sendMessage(MSG_GET_INTENT_DESCRIPTION + ' ' + additionalInfo.button.intent, null);
                }
                if (additionalInfo.button.hasOwnProperty('newWindow')) {
                    newWindow = additionalInfo.button.newWindow === 1;
                }
            }
            openUrl(href, newWindow, undefined, this.state.isStandalone);
        } else {
            await this.sendMessage(message, href, true)
        }
    }

    scrollToBottom = () => {
        if (this.messagesEnd) {
            this.messagesEnd.scrollIntoView({behavior: "smooth"})
        }
    }

    separateMessage = (data) => {
        if (data.Content === null || data.Type === TYPE_EVENT) {
            return [data]
        }
        let messages = data.Content.split('[!]')
        let separatedMessages = []
        if (messages.length) {
            messages.forEach((message => {
                let newData = Object.assign({}, data);
                newData.Content = message
                separatedMessages.push(newData)
            }))
            return separatedMessages
        } else {
            return [data]
        }
    }

    setLastMessageContext = (context) => {
        this.lastMessageContext = context;
    }

    checkIsLastMessage = (messages, key) => {
        let isLast = true;
        for (let i = key; i < messages.length; i++) {
            let nextMessage = messages[i + 1];
            if (!nextMessage) {
                break;
            } else {
                if (nextMessage.Type === TYPE_EVENT) {
                    continue;
                }
                if (!this.state.agentConnected
                    && nextMessage.Type === TYPE_MESSAGE
                    && nextMessage.ParticipantRole === ROLE_CUSTOMER
                    && nextMessage.Content === MSG_WAITING_AGENT
                ) {
                    isLast = false;
                    break;
                }
                try {
                    let data = JSON.parse(nextMessage.Content);
                    if (data.type !== TYPE_EVENT) {
                        isLast = false;
                        break;
                    }
                } catch (e) {
                    if (!this.state.agentConnected
                        && nextMessage.Type === TYPE_MESSAGE
                        && nextMessage.ParticipantRole === ROLE_SYSTEM
                    ) {
                        isLast = false;
                        break;
                    }
                }
            }
        }
        return isLast;
    }

    filterFeedbackMessage = () =>{
        let messages = this.state.filteredMessages||[];
        if(messages.length) {
            const removeMessageKey = messages.findIndex(obj =>
                obj && obj.Type === CONTENT_TYPE_EVENT
                && obj.ContactId === this.getCurrentContactId()
                && obj.ContentType === CONTENT_TYPE_FEEDBACK
                && obj.transferFeedback
            )
            if (removeMessageKey !== -1){
                messages.splice(removeMessageKey,1)
            }
        }
        return messages
    }

    renderMessages() {
        const {messages} = this.state;
        let agentParticipantId = null;
        let lastCustomerMessageId = null;
        this.state.filteredMessages = messages.filter(message => {
            const skipJoinedMessage = (
                message.ParticipantRole === ROLE_AGENT
                && message.Type === 'EVENT'
                && message.ContentType === CONNECT_EVENT_JOINED
                && message.ParticipantId === agentParticipantId
            );
            // save agent joined
            if (message.ParticipantRole === ROLE_AGENT
                && message.Type === 'EVENT'
                && message.ContentType === CONNECT_EVENT_JOINED
                && message.ParticipantId !== agentParticipantId
            ) {
                agentParticipantId = message.ParticipantId;
            }

            //save last customer message id (for history)
            if (message.ParticipantRole === ROLE_CUSTOMER
                && message.Type === TYPE_MESSAGE
                && message.Content !== MSG_START_CHAT
                && message.Content.indexOf(MSG_GET_INTENT_DESCRIPTION) === -1
            ) {
                lastCustomerMessageId = message.Id;
            }
            if (message.ContentType === CONNECT_EVENT_TRANSFER_SUCCEEDED) {
                message.Content = 'Chat transferred by Agent ' + getTimeAMPMFormat(new Date())
                message.ContentType= CONTENT_TYPE_TRANSFER
            }
            return !(message.Content && (
                    message.Content === MSG_START_CHAT
                    || message.Content.indexOf(MSG_GET_INTENT_DESCRIPTION) !== -1
                )
                || skipJoinedMessage
            );
        });
        return this.state.filteredMessages.map((message, key) => {
            if (message.ParticipantRole === ROLE_CUSTOMER) {
                if (isIntentsHistoryEnabled()) {
                    message.isLastMessageForRole = (message.Id === lastCustomerMessageId
                        && !this.state.chatEnded
                        && !this.state.agentConnected
                        && !this.state.showCancelButton
                    );
                }
                // always transform sys_back message
                if (message.Type === TYPE_MESSAGE) {
                    if (message.Content.indexOf("sys_back:") === 0) {
                        message.Content = message.Content.split(':')[2];
                    }
                }
            }
            return this.renderMessage(message, key);
        });
    }

    renderMessage = (message, key) => {
        const {
            username,
            avatarUrl,
            showCancelButton,
            cancelButtonTitle,
            showRestartChat,
            newSession,
            filteredMessages,
            feedbackValue,
            showFeedback,
            chatEnded
        } = this.state;
        let {prescription} = this.state;
        let isHidden = false;
        if (message.ParticipantRole === ROLE_SYSTEM && !message.ParticipantId) {
            message.ParticipantId = this.state.systemParticipantId;
        }
        if (message.DisplayName === DISPLAY_NAME_BOT || message.DisplayName === DISPLAY_NAME_SYSTEM_MESSAGE) {
            try {
                let messageJson = JSON.parse(message.Content);
                if (messageJson.type === CONTENT_TYPE_EVENT && messageJson.customerDOB && prescription && !prescription.customerDOB) {
                    if (typeof messageJson.additionalData === 'string') {
                        try {
                            messageJson.additionalData = JSON.parse(messageJson.additionalData);
                        } catch (e) {
                            messageJson.additionalData = {};
                        }
                    }
                    if ((messageJson.additionalData || {}).prescription) {
                        prescription = messageJson;
                        this.setState({
                            prescription: messageJson
                        });
                    }
                }
            } catch (e) {
            }
        }

        const isLast = this.checkIsLastMessage(filteredMessages, key);
        const nextMessage = filteredMessages[key + 1];
        if (nextMessage && nextMessage.Type !== TYPE_EVENT) {
            try {
                let data = JSON.parse(nextMessage.Content);
                isHidden = data.hidden === true;
            } catch (e) {
            }
        }

        return <Template init={this.setLastMessageContext.bind(this)}
                         key={'tpl_' + key}
                         dataKey={'tpl_' + key}
                         config={this.props.config}
                         contactId={message.ContactId}
                         type={message.ContentType}
                         role={message.ParticipantRole}
                         message={message.Content}
                         currentQueueName={this.state.currentQueueName}
                         displayName={message.DisplayName}
                         /*acceptedAgreement={this.state.acceptedAgreement}*/
                         username={username}
                         avatar={avatarUrl}
                         showCancelButton={showCancelButton}
                         cancelButtonTitle={cancelButtonTitle}
                         showRestartChat={showRestartChat}
                         onButtonClick={this.onButtonClick}
                         newSession={newSession}
                         cancelLiveChat={this.cancelLiveChat}
                         restartChat={this.restartChat}
                         scrollToBottom={this.scrollToBottom}
                         prescription={prescription}
                         last={isLast}
                         isLastInChain={
                             (
                                 (
                                     nextMessage
                                     && ((nextMessage.ParticipantId !== message.ParticipantId
                                         && !([ROLE_SYSTEM, ROLE_AGENT].indexOf(nextMessage.ParticipantRole) !== -1
                                             && [ROLE_SYSTEM, ROLE_AGENT].indexOf(message.ParticipantRole) !== -1)
                                         && nextMessage.ContentType !== CONNECT_EVENT_LEFT
                                         && nextMessage.Type !== TYPE_EVENT
                                     ))
                                 )
                                 || nextMessage === undefined
                                 || nextMessage.hide === true
                                 || nextMessage.ContentType === CONNECT_EVENT_LEFT && nextMessage.ParticipantRole !== filteredMessages[key].ParticipantRole && nextMessage.ParticipantRole === ROLE_AGENT
                                 || nextMessage.ContentType === CONNECT_EVENT_LEFT && nextMessage.ParticipantRole === filteredMessages[key].ParticipantRole && nextMessage.ParticipantRole === ROLE_CUSTOMER
                                 || isHidden
                             )
                         }
                         isLastMessageForRole={message.isLastMessageForRole}
                         isSafari={this.state.isSafari}
                         sendFeedback={this.sendFeedback}
                         sendMessage={this.sendMessage}
                         feedbackValue={feedbackValue}
                         showFeedback={showFeedback}
                         isStandalone={this.state.isStandalone}
                         askName={this.state.askName}
                         askDOB={this.state.askDOB}
                         onUpdateFeedback={this.onUpdateFeedback}
                         agents={this.state.agents}
                         feedbackLoaderStatus={this.state.feedbackLoaderStatus}
                         chatEnded={this.state.chatEnded}
                         chatEndedByCustomer={this.state.chatEndedByCustomer}
                         transferFeedback={message.transferFeedback?message.transferFeedback:false}
                         showCancelFeedback={this.state.showCancelFeedback}
                         showTimeoutMessage={this.state.showTimeoutMessage}
                         changeFeedbackMessage={this.changeFeedbackMessage}
                         skipFeedback={this.skipFeedback}
                         showThanksMessage={this.state.showThanksMessage}
        />
    }

    makeId = (length = 20, characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => {
        var result = '';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    endLiveChatButton = () => {
        return this.state.showEndLiveChat ?
            <a className="endLiveChatButton"
               tabIndex="0"
               onClick={() => this.endLiveChat(false)}
               onKeyDown={keydownHandler}>
                End Live Chat
            </a>
            :
            <></>
    }

    chatHeaderLogo = () => {
        const {logoUrl} = this.state;
        const chatLogo = (this.props.config || {}).chatLogo;
        return <img src={logoUrl ? logoUrl : (chatLogo ? chatLogo : HEADER_SVG)} className="logo" alt=""/>
    }

    chatHeader = () => {
        const {headerColor} = this.state;
        return <header className="header__chat row"
                    style={{backgroundColor: headerColor ? headerColor : "rgba(255, 255, 255, 1)"}}>
            {
                this.state.isStandalone ?
                    <Row className="header__inner">
                        {this.chatHeaderLogo()}
                        {this.endLiveChatButton()}
                    </Row>
                    :
                    <>
                        {this.chatHeaderLogo()}
                        {this.endLiveChatButton()}
                    </>
            }
        </header>
    }

    chatMessages = () => {
        const { agents, contactId, showThanksMessage, showTimeoutMessage,showFeedback,feedbackValue,showCancelThanksMessage,skipFeedback} = this.state;
        const chatEnded = agents[this.state.contactId] ? agents[this.state.contactId].chatEnded : "";
        return <main className="justify-content-md-center messages row" ref={c => this.messagesArea = c}>
            {this.renderMessages()}
            {
                this.state.isTyping ?
                    this.renderMessage({ContentType: CONTENT_TYPE_TYPING}, -1)
                    :
                    <></>
            }
            {
                (chatEnded || showCancelThanksMessage ) && !showFeedback  && feedbackValue[contactId]
                && showThanksMessage && !skipFeedback
                && <div className="message-box "><div className="feedback thanks">
                    Thank you for taking time to give us feedback on your chat experience.
                </div></div>
            }
            {
                chatEnded && showTimeoutMessage
                && <div className="message-box "><div className="feedback thanks">
                    Chat session ended due to inactivity. Please refresh your screen.
                </div></div>
            }

            <div style={{float: "left", clear: "both"}}
                 ref={(el) => {
                     this.messagesEnd = el
                 }}>
            </div>
        </main>
    }

    chatInputTextarea = () => {
        const {lexEnter, message, askName, showFeedback, agents, feedbackValue, showCancelFeedback} = this.state;
        const contactId = showFeedback && this.state.chatEnded ? this.getCurrentContactId() : '';
        const chatEnded = agents[contactId] ? agents[contactId].chatEnded : '';
        return <TextareaAutosize
            tabIndex={lexEnter ? 0 : -1}
            autoFocus={false}
            ref={c => this.textarea = c}
            className="chat__input"
            placeholder={ "Type your question here..."}
            value={message}
            disabled={(!lexEnter || askName)}
            onChange={(e) => {
                this.changeMessage(e)
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    this.sendMessage(message, null, true);
                }
            }}
        />
    }

    chatInputTextareaStandalone = () => {
        const {lexEnter, message, askName, showFeedback, feedbackValue, agents, showCancelFeedback} = this.state;
        const contactId = showFeedback && this.state.chatEnded ? this.getCurrentContactId() : '';
        const chatEnded = agents[contactId] ? agents[contactId].chatEnded : '';
        return <input
            tabIndex={lexEnter ? 0 : -1}
            autoFocus={false}
            ref={c => this.textarea = c}
            className="chat__input"
            placeholder={"Type your question here..."}
            value={message}
            disabled={(!lexEnter || askName)}
            onChange={(e) => {
               this.changeMessage(e)
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    if (askName) {
                        return false;
                    }
                    this.sendMessage(message, null, true);
                }
            }}
        />
    }

    chatInputSendButton = () => {
        let contactId = this.state.showFeedback && this.state.chatEnded?this.getCurrentContactId():''
        const chatEnded = this.state.agents[contactId]?this.state.agents[contactId].chatEnded:""
        return <button className="sendMessage"
                       tabIndex={(this.state.lexEnter && !this.state.askName) ? 0 : -1}
                       ref={c => this.sendMessageButton = c}
                       disabled={!this.state.lexEnter}
                       onClick={() => {
                           if (this.state.askName) {
                               return false;
                           }
                          this.sendMessage(this.state.message, null, true);
                       }}
                       onKeyDown={keydownHandler}>
            {SEND_MESSAGE_BUTTON}
        </button>
    }

    chatInputSendStandalone = () => {
        let contactId = this.state.showFeedback && this.state.chatEnded?this.getCurrentContactId():''
        const chatEnded = this.state.agents[contactId]?this.state.agents[contactId].chatEnded:""
        return <a className="sendMessage"
                  tabIndex={(this.state.lexEnter && !this.state.askName) ? 0 : -1}
                  ref={c => this.sendMessageButton = c}
                  onClick={() => {
                      if(!this.state.lexEnter && this.state.askName)
                          return false;

                      this.sendMessage(this.state.message, null, true)
                  }}
                  onKeyDown={keydownHandler}>
            {SEND_MESSAGE_BUTTON}
        </a>
    }

    chatInput = () => {
        return <footer className={"input__container " + (this.state.showFeedback && this.state.chatEnded && !this.state.chatCanceled?"hidden":"")}>
            {
                this.state.isStandalone ?
                    <Row className="input__inner">
                        {this.chatInputTextareaStandalone()}
                        {this.chatInputSendStandalone()}
                    </Row>
                    :
                    <>
                        {this.chatInputTextarea()}
                        {this.chatInputSendButton()}
                    </>
            }
        </footer>
    }

    render() {
        const {
            backgroundColor,
            fontName,
            cssUrl,
        } = this.state;

        return (
            <Container className="chat__wrap"
                       id="chat__wrap"
                       style={{backgroundColor: backgroundColor ? backgroundColor : "rgba(255, 255, 255, 1)"}}>
                {
                    <style>
                        {
                            "@import url('https://fonts.googleapis.com/css?family=" + fontName + "');" +
                            "* {\n" +
                            "    font-family: '" + fontName + "', sans-serif;\n" +
                            "    font-weight: normal;\n" +
                            "    font-size: 16px\n" +
                            "}"
                        }
                    </style>
                }
                {
                    cssUrl && <link rel="stylesheet" id="style-direction" href={cssUrl}/>
                }

                {this.chatHeader()}

                {this.chatMessages()}

                {this.chatInput()}

            </Container>
        )
    }
}
